import { combineReducers } from "redux";
import * as CsvUploader from "./CsvUploaderReducer";
import * as InbreedingData from "./InbreedingCalculationsReducer";
import * as BullData from "./BullCodeReducer";

/*
 * This is the root state of the app
 * It contains every substate of the app
 */
export interface IGlobalState {
  csvUploaderState: CsvUploader.IState;
  inbreedingState: InbreedingData.IState;
  bullCodes: BullData.IState;
}

/*
 * initialState of the app
 */
export const initialState: IGlobalState = {
  csvUploaderState: CsvUploader.initialState,
  inbreedingState: InbreedingData.initialState,
  bullCodes: BullData.initialState,
};

/*
 * Root reducer of the app
 * Returned reducer will be of type Reducer<State>
 */
export const reducer = combineReducers<IGlobalState>({
  csvUploaderState: CsvUploader.reducer,
  inbreedingState: InbreedingData.reducer,
  bullCodes: BullData.reducer,
});



// WEBPACK FOOTER //
// ./src/scripts/reducers/IndexReducer.ts